import { Observable } from "rxjs/internal/Observable";
import { SnapshotRequest } from "./models/snapshot-request";

export abstract class CameraSnapshotBase {
    abstract postSnapshot(device_id: number, width?: number, height?: number): Observable<SnapshotRequest>;
    abstract fetchSnapshotRequest(request_id: string): Observable<any>;
}